import React, { useEffect, useState} from 'react';
import { NavLink } from 'react-router-dom';
import 'react-toastify/dist/ReactToastify.css';
import styled from 'styled-components';
import SimpleImageSlider from "react-simple-image-slider";
import Logo from "../assets/prontobau_logo.png";
import Banner from "../assets/banner.PNG";
import { Fade, LightSpeed, Bounce, Slide, Zoom } from 'react-reveal';
import {motion} from "framer-motion";

function App() {

useEffect(() => {

}, []);



  return (
    <Section>
    <motion.div className='container'
        initial={{opacity: 0}}
        animate={{opacity: 1}}
        exit={{opacity: 0}}>
        <h1 className='title'>Impressum</h1>
        <div className="lcContainer">
                    <Zoom duration={800}>
                    <div className="lc">
                        <div className="lcContent">
                        <h1 className='headText'>
                            <img src="https://static.wixstatic.com/media/bd4388_9735aed58f34479782896370a64a0177~mv2.png/v1/fill/w_50,h_50,al_c,q_85,usm_0.66_1.00_0.01,enc_auto/prontobau_symbol02.png" alt="" />
                            Für den Inhalt verantwortlich
                        </h1>
                        <div className="description">
                            <p>
                                <span>PRONTO Bau GmbH</span><br/>Harrstraße 2, A-4470 Enns (OÖ)<br/><span>M:</span> <a href="mailto:office@pronto-bau.at">office@pronto-bau.at</a>
                                <br/>
                                <br/>
                                <b><span>1. Inhalt des Onlineangebotes</span></b>
                                <br/>
                                <br/>
                                Der Autor übernimmt keinerlei Gewähr für die Aktualität, Korrektheit, Vollständigkeit oder Qualität der bereitgestellten Informationen. Haftungsansprüche gegen den Autor, welche sich auf Schäden materieller oder ideeller Art beziehen, die durch die Nutzung oder Nichtnutzung der dargebotenen Informationen bzw. durch die Nutzung fehlerhafter und unvollständiger Informationen verursacht wurden, sind grundsätzlich ausgeschlossen, sofern seitens des Autors kein nachweislich vorsätzliches oder grob fahrlässiges Verschulden vorliegt. Alle Angebote sind freibleibend und unverbindlich. Der Autor behält es sich ausdrücklich vor, Teile der Seiten oder das gesamte Angebot ohne gesonderte Ankündigung zu verändern, zu ergänzen, zu löschen oder die Veröffentlichung zeitweise oder endgültig einzustellen.
                                <br/>
                                <br/>
                                <b><span>2. Verweise und Links</span></b>
                                <br/>
                                <br/>
                                Bei direkten oder indirekten Verweisen auf fremde Internetseiten (Links), die außerhalb des Verantwortungsbereiches des Autors liegen, würde eine Haftungsverpflichtung ausschließlich in dem Fall in Kraft treten, in dem der Autor von den Inhalten Kenntnis hat und es ihm technisch möglich und zumutbar wäre, die Nutzung im Falle rechtswidriger Inhalte zu verhindern. Der Autor erklärt hiermit ausdrücklich, dass zum Zeitpunkt der Linksetzung keine illegalen Inhalte auf den zu verlinkenden Seiten erkennbar waren. Auf die aktuelle und zukünftige Gestaltung, die Inhalte oder die Urheberschaft der gelinkten/verknüpften Seiten hat der Autor keinerlei Einfluss. Deshalb distanziert er sich hiermit ausdrücklich von allen Inhalten aller gelinkten/verknüpften Seiten, die nach der Linksetzung verändert wurden. Diese Feststellung gilt für alle innerhalb des eigenen Internetangebotes gesetzten Links und Verweise sowie für Fremdeinträge in vom Autor eingerichteten Gästebüchern, Diskussionsforen und Mailinglisten. Für illegale, fehlerhafte oder unvollständige Inhalte und insbesondere für Schäden, die aus der Nutzung oder Nichtnutzung solcherart dargebotener Informationen entstehen, haftet allein der Anbieter der Seite, auf welche verwiesen wurde, nicht derjenige, der über Links auf die jeweilige Veröffentlichung lediglich verweist.
                                <br/>
                                <br/>
                                <b><span>3. Urheber- und Kennzeichenrecht</span></b>
                                <br/>
                                <br/>
                                Der Autor ist bestrebt, in allen Publikationen die Urheberrechte der verwendeten Grafiken, Tondokumente, Videosequenzen und Texte zu beachten, von ihm selbst erstellte Grafiken, Tondokumente, Videosequenzen und Texte zu nutzen oder auf lizenzfreie Grafiken, Tondokumente, Videosequenzen und Texte zurückzugreifen. Alle innerhalb des Internetangebotes genannten und ggf. durch Dritte geschützten Marken- und Warenzeichen unterliegen uneingeschränkt den Bestimmungen des jeweils gültigen Kennzeichenrechts und den Besitzrechten der jeweiligen eingetragenen Eigentümer. Allein aufgrund der bloßen Nennung ist nicht der Schluss zu ziehen, dass Markenzeichen nicht durch Rechte Dritter geschützt sind! Das Copyright für veröffentlichte, vom Autor selbst erstellte Objekte bleibt allein beim Autor der Seiten. Eine Vervielfältigung oder Verwendung solcher Grafiken, Tondokumente, Videosequenzen und Texte in anderen elektronischen oder gedruckten Publikationen ist ohne ausdrückliche Zustimmung des Autors nicht gestattet.
                                <br/>
                                <br/>
                                <b><span>4. Rechtswirksamkeit dieses Haftungsausschlusses</span></b>
                                <br/>
                                <br/>
                                Dieser Haftungsausschluss ist als Teil des Internetangebotes zu betrachten, von dem aus auf diese Seite verwiesen wurde. Sofern Teile oder einzelne Formulierungen dieses Textes der geltenden Rechtslage nicht, nicht mehr oder nicht vollständig entsprechen sollten, bleiben die übrigen Teile des Dokumentes in ihrem Inhalt und ihrer Gültigkeit davon unberührt.




                            </p>
                        </div>
                        </div>
                </div>
                </Zoom>
        </div>
    </motion.div>
    </Section>
  );
}

export default App;

const Section = styled.section`
width: 100%;
min-height: 100%;
overflow-x: hidden;

.mailBtn{
    background-color: #252E32;
    padding: 10px 30px;
    border-radius: 20px;
    color: #5BBCB0;
    transition: all 0.3s;
    text-decoration: none;
}
.mailBtn:hover{
    background-color: #5BBCB0;
    color: #fff;
}
.container{
    padding-top: 0px;
  display: flex;
  flex-direction: column;
  gap: 2rem;
  margin-bottom: 30px;
justify-content: center;
align-items: center;
text-align: center;
  height: 100%;
  width: 100%;
.title{
    background-image: url(${Banner});
    background-size: cover;
    width: 100vw;
    min-height: 120px;
    background-position: 50% 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    color: #fff;

}
  h1{
    color: #5BBCB0;
    font-size: 40px;
  }
}
.lcContainer{
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    gap: 2rem;
  justify-content: center;
  align-items: center;
  text-align: center;
}
.lc{
    background-color: #fff;
    border-radius: 5px;
    max-width: 900px;
    width: 100%;
    display: flex;
    gap: 20px;
    padding: 30px;
    .lcContent{s
        height: 100%;
        width: 100%;
        display: flex;
        flex-direction: column;
        gap: 20px;
    }
    .headText{
        display: flex;
        gap: 10px;
        align-items: center;
        font-weight: 400;
        font-size: 30px;
        top: 0;
        left: 0;
    }
    .description{
        width: 100%;
        display: flex;
        text-align: start;

        span{
            color: #5BBCB0;
        }
        a{
            color: #000;
        }
    }
    .image{
        width: 100%;
        right: 0;
        top: 41.5px;
        border-radius: 3px;
    }
}
@media screen and (min-width: 280px) and (max-width: 1080px) {
    .lcContainer{
        padding: 10px;
    }
.lc{

}

}

`;
